module.exports = __webpack_public_path__ + "static/media/03_Personalized.3ad8e65a.svg";